import { setToken } from 'lib/common'
import { globalConst as native, mutationNames } from 'lib/const'
import { isEmptyObject, margeMutations } from 'lib/utils'
import { applyClientMiddleware } from 'src/main'
import api from 'api/api'
import PackageFile from 'lib/packageFile'
import { createModule } from 'plugins/vuex-request/VuexModule'

const state = {
  newVersion: null,
  newVersionUrl: ''
}

const getters = {}
const actions = {
  loadServerUrl (state, refs) {
    return applyClientMiddleware(api.loadServerUrl, refs)
  },
  [native.loadNowVersion] (state, refs) {
    if (!state.nowVersion) {
      return applyClientMiddleware(api.loadNowVersion, refs)
    }
  }
}
let mutations = {
  [mutationNames.loadNowVersion_request] () {
  },
  [mutationNames.loadNowVersion_success] (state, {data}) {
    let {version, serverUpdateUrl} = data
    state.newVersion = version
    state.newVersionUrl = serverUpdateUrl
  }
}
mutations = Object.assign(margeMutations(actions), mutations)
export default createModule(state, getters, actions, mutations, false)
